import { Container, Button, ProductImage } from "@/components/atoms";

// Meet Dr. Burns (frame 23:2).
export function MeetDrBurns() {
  return (
    <section className="py-14">
      <Container className="grid items-center gap-10 md:grid-cols-2">
        <div className="w-full max-w-md rounded-[20px] bg-gradient-to-br from-healthy-blue via-healthy-blue/80 to-leaf-green/70 p-1 shadow-[0_14px_40px_rgba(60,113,184,0.24),0_4px_12px_rgba(0,0,0,0.08)]">
          <ProductImage
            src="https://firebasestorage.googleapis.com/v0/b/drburns-web.firebasestorage.app/o/about%2Fdr-burns.png?alt=media"
            alt="Dr. Elaine Burns"
            name="Dr. Elaine Burns"
            className="aspect-square w-full !rounded-2xl bg-gradient-to-br from-medical-grey to-white"
            imgClassName="object-cover object-top"
          />
        </div>
        <div className="flex flex-col gap-4">
          <span className="font-condensed text-xs font-bold uppercase tracking-widest text-leaf-green-ink">
            Meet the Founder
          </span>
          <h2 className="font-condensed text-3xl font-bold text-night-blue">
            Dr. Elaine Burns
          </h2>
          {/* Sourced from Dr. Burns' own evaluationtoday.com/about-us at her request (2026-08-11). */}
          <p className="text-night-blue/70">
            An Arizona-licensed Naturopathic Physician who has served Arizona
            patients since 2011, and the first in the state to pass the American
            Academy of Cannabinoid Medicine (AACM) physician certification in
            2012. With over 15 years and counting of clinical experience, Dr.
            Burns formulates every product herself, pairing CBD with superior
            botanicals to deliver tailored effects for specific conditions.
          </p>
          <blockquote className="border-l-4 border-leaf-green pl-4 italic text-night-blue/80">
            “Our mission is to ensure patients have access to consistently
            high-quality therapeutic products rooted in science, not folklore.”
          </blockquote>
          <Button to="/about" variant="outline" className="w-fit">
            Read Her Story
          </Button>
        </div>
      </Container>
    </section>
  );
}
